'use client';

import { c as _c } from "react/compiler-runtime";
import { useMemo } from 'react';
import { useCountries } from '@/lib/hooks/useCountries';
import { TagMultiSelector } from './TagMultiSelector';
interface CountrySelectorProps {
  selectedIds: string[];
  onSelectionChange: (ids: string[]) => void;
  disabled?: boolean;
  mode?: 'dropdown' | 'combobox';
  label?: string;
  placeholder?: string;
  searchPlaceholder?: string;
}
export function CountrySelector(t0) {
  const $ = _c(13);
  const {
    selectedIds,
    onSelectionChange,
    disabled: t1,
    mode: t2,
    label: t3,
    placeholder: t4,
    searchPlaceholder: t5
  } = t0;
  const disabled = t1 === undefined ? false : t1;
  const mode = t2 === undefined ? "dropdown" : t2;
  const label = t3 === undefined ? "Countries" : t3;
  const placeholder = t4 === undefined ? "Select countries..." : t4;
  const searchPlaceholder = t5 === undefined ? "Search countries..." : t5;
  const {
    data: t6,
    isLoading
  } = useCountries();
  let t7;
  if ($[0] !== t6) {
    t7 = t6 === undefined ? [] : t6;
    $[0] = t6;
    $[1] = t7;
  } else {
    t7 = $[1];
  }
  const countries = t7;
  let t8;
  if ($[2] !== countries) {
    t8 = countries.sort(_temp).map(_temp2);
    $[2] = countries;
    $[3] = t8;
  } else {
    t8 = $[3];
  }
  const options = t8;
  const t9 = isLoading ? "Loading countries..." : placeholder;
  const t10 = disabled || isLoading;
  let t11;
  if ($[4] !== label || $[5] !== mode || $[6] !== onSelectionChange || $[7] !== options || $[8] !== searchPlaceholder || $[9] !== selectedIds || $[10] !== t10 || $[11] !== t9) {
    t11 = <TagMultiSelector label={label} placeholder={t9} searchPlaceholder={searchPlaceholder} options={options} selectedIds={selectedIds} onSelectionChange={onSelectionChange} disabled={t10} mode={mode} />;
    $[4] = label;
    $[5] = mode;
    $[6] = onSelectionChange;
    $[7] = options;
    $[8] = searchPlaceholder;
    $[9] = selectedIds;
    $[10] = t10;
    $[11] = t9;
    $[12] = t11;
  } else {
    t11 = $[12];
  }
  return t11;
}
function _temp2(c) {
  return {
    id: c.alpha3,
    label: `${c.emoji} ${c.name}`
  };
}
function _temp(a, b) {
  return a.name.localeCompare(b.name);
}